<section>
  <div class="container-style">
    <form novalidate [formGroup]="formPrintQuotation" class="py-1 px-2">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12 mb-1">
          <p>Seleccione la versión que desea imprimir.</p>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-12 mb-2">
          <app-custom-select formControlName="quotationVersionId" [labelText]="'Versión'" [list]="listVersions"
            [required]="true" (onChangeSelect)="getVersionSelect($event)"></app-custom-select>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-12 mb-2">
          <app-custom-checkbox formControlName="swBreakdown" [labelText]="'Incluir Despiece'"></app-custom-checkbox>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end">
          <app-custom-button [label]="'Imprimir'" [severity]="'primary'" [variant]="undefined" [width]="'5rem'"
            (onClick)="printVersion()"></app-custom-button>
        </div>
      </div>
    </form>
  </div>
</section>